import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RoofSunroofProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RoofSunroof(props: RoofSunroofProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Roof"
      width={443}
      height={320}
      viewBox="0 0 443 320"
      position={{top: 91, left: 573}}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M439 2C427.99 11.1234 427.997 27.6032 428 36.5469V37L428.134 160L428 283V283.453C427.997 292.397 427.99 308.877 439 318C326.944 303.112 133.993 303.791 59 311C47.0684 312.147 33.7836 314.928 20 317.881C13.6666 302.575 1.00005 254.996 1 187.92V132.08C1.00005 65.0042 13.6666 17.4245 20 2.11914C33.7836 5.07208 47.0684 7.85297 59 9C133.993 16.2094 326.944 16.8876 439 2ZM74.0713 50C65.7143 50 59.4532 53.0091 55.5 64.915C49 84.4913 49 160 49 160C49 160 49 235.509 55.5 255.085C59.4532 266.991 65.7143 270 74.0713 270H236.107C247.714 270 257 263.474 257 249.491V70.5088C257 56.5259 247.714 50.0001 236.107 50H74.0713Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M428 283L428.134 160L428 37L428 36.547C427.997 27.6033 427.99 11.1234 439 2C326.944 16.8876 133.993 16.2094 59 9C47.0684 7.85297 33.7836 5.07178 20 2.11884C13.6667 17.424 1 65.004 1 132.08V160V187.92C1 254.996 13.6667 302.576 20 317.881C33.7836 314.928 47.0684 312.147 59 311C133.993 303.791 326.944 303.112 439 318C427.99 308.877 427.997 292.397 428 283.453L428 283Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M16 14C29 17.0276 44.0983 19.9281 56 21.0643C130 28.1287 318.523 29.0866 431 14"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M16 306C29 302.972 44.0983 300.072 56 298.936C130 291.871 318.523 290.913 431 306"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M408 164V160V156C408 152 402.955 152 397 152H397C390.053 152 387.939 152.333 380 155C372.742 157.438 366 154.667 366 160C366 164.97 372.742 162.562 380 165C387.939 167.667 390.053 168 397 168C402.955 168 408 168 408 164Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M408 164V160V156C408 152 402.955 152 397 152H397C390.053 152 387.939 152.333 380 155C372.742 157.438 366 154.667 366 160C366 164.97 372.742 162.562 380 165C387.939 167.667 390.053 168 397 168C402.955 168 408 168 408 164Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M366 160H401"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M407 154C407 154 401 156 401 160C401 164 407 166 407 166"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242.5 42C255 42 265 49 265 64V256C265 271 255 278 242.5 278H68C59 278 52.2573 274.772 48 262C41 241 41 160 41 160C41 160 41 79 48 58C52.2573 45.228 59 42 68 42H242.5ZM74.0713 49.5C69.8348 49.5 66.0625 50.2631 62.8418 52.5879C59.6236 54.9109 57.0216 58.7456 55.0254 64.7578C53.3802 69.7128 52.1579 78.1556 51.2441 87.9844C50.3289 97.8289 49.7189 109.113 49.3125 119.779C48.9061 130.446 48.7032 140.501 48.6016 147.889C48.5508 151.582 48.5254 154.61 48.5127 156.714C48.5063 157.766 48.5035 158.587 48.502 159.146C48.5012 159.425 48.5002 159.639 48.5 159.782V159.999C48.5 159.999 48.5 160 49 160C48.5 160 48.5 160.001 48.5 160.001V160.218C48.5002 160.361 48.5012 160.575 48.502 160.854C48.5035 161.413 48.5063 162.234 48.5127 163.286C48.5254 165.39 48.5508 168.418 48.6016 172.111C48.7032 179.499 48.9061 189.554 49.3125 200.221C49.7189 210.887 50.3289 222.171 51.2441 232.016C52.1579 241.844 53.3802 250.287 55.0254 255.242C57.0216 261.254 59.6236 265.089 62.8418 267.412C66.0625 269.737 69.8348 270.5 74.0713 270.5H236.107L236.658 270.495C242.333 270.395 247.475 268.735 251.24 265.362C255.136 261.873 257.5 256.6 257.5 249.491V70.5088C257.5 63.3999 255.136 58.1272 251.24 54.6377C247.354 51.1562 242 49.5001 236.107 49.5H74.0713Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        opacity="0.8"
        d="M236.107 270H74.0714C65.7143 270 59.4532 266.991 55.5 255.085C49 235.508 49 160 49 160C49 160 49 84.4915 55.5 64.9153C59.4532 53.0091 65.7143 50 74.0714 50H236.107C247.714 50 257 56.5254 257 70.5085V160V249.492C257 263.475 247.714 270 236.107 270Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M242.5 278H68C59 278 52.2573 274.772 48 262C41 241 41 160 41 160C41 160 41 79 48 58C52.2573 45.228 59 42 68 42H242.5C255 42 265 49 265 64V160V256C265 271 255 278 242.5 278Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M236.107 270H74.0714C65.7143 270 59.4532 266.991 55.5 255.085C49 235.508 49 160 49 160C49 160 49 84.4915 55.5 64.9153C59.4532 53.0091 65.7143 50 74.0714 50H236.107C247.714 50 257 56.5254 257 70.5085V160V249.492C257 263.475 247.714 270 236.107 270Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
